namespace advisorop.components.common {


    export class NewCuProposalController {
        accountId: number;

        onProposalCreate: any;
        onProposalSign: any;
        //account: domains.IAccount;
        rtq: domains.IRTQ;
        onCheckedSkippingOption: any;
        fuOptions: DevExpress.ui.dxFileUploaderOptions;
        fuValue: File[] = [];
        onAccountOpenStatusChanged: any;
        isHhrProposal: string;
        custodianReadOnly: boolean;

        isAdvisoryFirmLoaded: boolean = false;
        proposalState = domains.ProposalState;
        proposalState_PREPARING = domains.ProposalState.PREPARING;
        proposalState_ACTIVE = domains.ProposalState.ACTIVE;
        proposalState_SIGNED = domains.ProposalState.SIGNED;
        dgInvestmentSettings: DevExpress.ui.dxDataGridOptions;
        otherFees: domains.IOtherProposalFee;
        timesHorizons: Array<domains.ILOV>;
        lovs: Array<domains.ILOV> = [];
        selectedTimeHorizon: domains.ILOV;
        proposalId: number; //when we wish to update proposal...
        investmentModels: Array<domains.IInvestmentModel> = [];
        otherAccountFees: Array<domains.IAccountProposalFees> = null;
        model: domains.IProposal = {
            id: 0,
            proposalState: domains.ProposalState.PREPARING,
            //custodianFee: { id: 0 },
            investmentModels: [],
            accountSetupOpen: false
        };
        proposalForEdit: domains.IProposal = {};
        im: domains.IProposalInvestmentModel = {};
        unallocatedInvestment: number;
        proposalSigned: boolean = false;
        disableForPost: boolean = false;
        numberBox: DevExpress.ui.dxNumberBoxOptions;
        thisAccountIsFromMapping: boolean = false;
        user: domains.identity.IUser;
        impersonatedByServicer: boolean = false;
        currentAdvisor: domains.IAdvisor;

        advisoryFirmId: number;
        accountType: domains.InvestmentType;
        managers: domains.IAdvisoryFirmManager[] = [];
        filteredManagers: domains.IAdvisoryFirmManager[] = [];
        selManager: domains.IAdvisoryFirmManager;
        products: domains.IAdvisoryFirmProduct[] = [];
        filteredProducts: domains.IAdvisoryFirmProduct[] = [];
        selProduct: domains.IAdvisoryFirmProduct;
        deactivatedInvestments: Array<domains.IProposalInvestmentModel> = [];
        investmentType: any = domains.InvestmentType;
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        //selCustodian: domains.ICustodianAdvisoryFirm;
        pricingTypes: domains.ILOV[];
        selPricingType: domains.ILOV = <domains.ILOV>{ value: domains.PricingType.ASSET_BASED };
        // showCheckbox: boolean = false;
        iAmReady: any;
        onSave: any;
        readyDone: boolean;
        accountOpened: boolean = false;
        investmentChange: boolean;
        cancelProposal: any;
        creatingProposalLadda: boolean = false;
        updatingProposalLadda: boolean = false;
        completeSigningLadda: boolean = false;
        signingProposalLadda: boolean = false;

        public billingTypes = [
            { text: "Percentage", value: domains.FeeBillingType.Percentage },
            { text: "Annual $", value: domains.FeeBillingType.Amount },
            { text: "Tiered", value: domains.FeeBillingType.Tiered }
        ];
        selAdvisorBillingType: { text: string; value: domains.FeeBillingType };
        public billingTypeEnum = domains.FeeBillingType;

        // Advanced Billing section
        advancedBilling: domains.IAdvancedBillingInfo = {};
        billingStyles = [
            { value: 1, description: "Advanced" },
            { value: 2, description: "Arrear" }
        ];
        billingFrequencies = [
            { value: 1, description: "Monthly" },
            { value: 2, description: "Quarterly" },
            { value: 3, description: "Tri-Annual" },
            { value: 4, description: "Semi-Annual" },
            { value: 5, description: "Annual" },
            { value: 6, description: "At-Maturity" }
        ];
        billingCycleMonthOptions: { value: number; description: string }[] = [];
        selBillingStyle: { value: number; description: string };
        selBillingFrequency: { value: number; description: string };
        selBillingCycleMonth: { value: number; description: string };
        showBillingFrequencyAndCycleFields: boolean = false;
        showBillingPanel: boolean = true;
        billingStatusColor: string = "yellow";
        billingInformationComplete: boolean = false;

        accountType_OutsideInvestment: number = domains.InvestmentType.OUTSIDE_INVESTMENT;
        accountType_DirectInvestment: number = domains.InvestmentType.DIRECT_INVESTMENT;
        accountType_IndividualHoldings: number = domains.InvestmentType.INDIVIDUAL_HOLDINGS;
        accountType_ManagedModels: number = domains.InvestmentType.MANAGED_MODELS;
        accountType_SMA: number = domains.InvestmentType.SMA;
        accountType_CustodianAccount: number = domains.InvestmentType.CUSTODIAN_ACCOUNT;

        completeColor: string = "lightgreen";
        incompleteColor: string = "yellow";
        investmentStatusColor: string = this.incompleteColor;
        investmentInformationComplete: boolean = false;
        showInvestmentsPanel: boolean = true;
        feeStatusColor: string = this.incompleteColor;
        feeInformationComplete: boolean = false;
        showFeesPanel: boolean = true;
        signingStatusColor: string = this.incompleteColor;
        signingInformationComplete: boolean = false;
        showSigningPanel: boolean = true;

        proposalDocumentCount: number = 0;
        
        orionAccountData: any = null;

        feeHelpPopupOptions: DevExpress.ui.dxPopoverOptions = {
            target: "#advisorProposalFeeHelp",
            showEvent: "mouseenter",
            hideEvent: "mouseleave",
            position: "left",
            width: 400,
            animation: {
                show: { type: "pop", from: { scale: 0 }, to: { scale: 1 } },
                hide: { type: "fade", from: 1, to: 0 }
            },
            showTitle: true,
            title: "Fees on other investor accounts",
            visible: false
        }

        dmsListCtrl: advisorop.components.advisor.DmsListController;

        static $inject = ["advisorService", "generalService", "identityService", "$filter", "$scope", "advisoryFirmApi", "accountApi"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            public $filter, private $scope: ng.IScope,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private accountApi: services.AccountApi) {

            $scope.$watch("vm.accountApi.paccount", () => {
                //console.log("New-Cu-Proposal: ACCOUNT ID HAS CHANGED to *************%%%%%%%%%%%%%%***************", this.accountApi.paccount.id);
                if (this.accountApi.paccount.id > 0) {
                    this.setProposal(this.accountApi.paccount.proposal);
                    this.loadOtherAccountProposalFees();
                    //console.log("SETTING PROPOSAL 1::", this.accountApi.paccount.proposal);
                    //this.loadWorkingProposal(this.accountApi.paccount.id);
                } else {

                }
            });

            $scope.$watch("vm.orionAccountData", () => {
                // Try to auto-select product when Orion account data is received
                if (this.orionAccountData && this.filteredProducts && this.filteredProducts.length > 0) {
                    // we don't want to trigger pre-select if already selected
                    if (this.model.investmentModels.length == 0) {
                        this.trySelectProductFromOrion();
                    }
                }
            });

            if (!this.model.id || this.model.id <= 0)
                this.unallocatedInvestment = 100;
            else
                this.unallocatedInvestment = 0;

            this.im.percentage = this.unallocatedInvestment;

            this.dgInvestmentSettings = {
                export: {
                    enabled: true,
                    fileName: "InvestmentModels"
                },
                bindingOptions: {
                    dataSource: "vm.model.investmentModels"
                    //,"columns[0].lookup.dataSource": "vm.investmentModels"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                noDataText: "There are no investment models",
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                columns: [
                    { dataField: "managerProductName", caption: "Product", visible: true },
                    { dataField: "productTypeName", caption: "Type", visible: true },
                    { dataField: "managerName", caption: "Manager", visible: true },
                    { dataField: "percentage", caption: "Percentage", format: { type: "percent", precision: 2 }, visible: true },
                    { dataField: "amount", caption: "Amount", format: { type: "fixedPoint", precision: 2 }, visible: true },
                    { dataField: "managerFeePercentage", caption: "Mgr. fee (%)", format: { type: "decimal", precision: 4 }, visible: true },
                    //{ dataField: "managerFeeAmount", caption: "Mgr. fee", format: { type: "fixedPoint", precision: 2 }, visible: true },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions" }
                ]
            };

            this.fuOptions = {
                bindingOptions: {
                    value: "vm.fuValue",
                    uploadUrl: "vm.propUploadUrl"
                },
                selectButtonText: "Upload a signed proposal document",
                labelText: "",
                multiple: false,
                uploadMode: "useButtons",
                accept: "*", // image/*  or video/*
                uploadButtonText: "Upload document"
            };

        }

        expandAll(): void {
            this.showInvestmentsPanel = true;
            this.showFeesPanel = true;
            this.showSigningPanel = true;
        }

        collapseCompleted(): void {
            if (this.investmentInformationComplete) {
                this.showInvestmentsPanel = false;
            }
            if (this.feeInformationComplete) {
                this.showFeesPanel = false;
            }
            if (this.signingInformationComplete) {
                this.showSigningPanel = false;
            }
        }

        collapseAll(): void {
            this.showInvestmentsPanel = false;
            this.showFeesPanel = false;
            this.showSigningPanel = false;
        }

        collapseSigned(): void {
            if (this.signingInformationComplete) {
                this.showSigningPanel = false;
            }
        }

        toggleInvestmentsPanel(): void {
            this.showInvestmentsPanel = !this.showInvestmentsPanel;
        }

        toggleFeesPanel(): void {
            this.showFeesPanel = !this.showFeesPanel;
        }

        toggleSigningPanel(): void {
            this.showSigningPanel = !this.showSigningPanel;
        }

        public get propUploadUrl(): string {
            return `/api/advisor/uploadsignedproposal/${this.model.id}/${this.model.accountId}`;
        }

        documentCountChanged(count: number) {
            this.proposalDocumentCount = count;
        }

        bindDMSList(ctrl: advisorop.components.advisor.DmsListController) {
            console.log("BINDING DMS LIST CONTROL...");
            this.dmsListCtrl = ctrl;
        }

        checkIfFieldsComplete(element: string, changedByUserOnUI: boolean = false, showMessage: boolean = false): boolean {
            var everythingComplete: boolean = true;

            this.selPricingType = <domains.ILOV>{ value: domains.PricingType.ASSET_BASED };

            //console.log("In checkIfFieldsComplete", element);

            // Check fee completeness based on billing type
            if (this.model.advisorFeeBillingType === domains.FeeBillingType.Tiered) {
                let minLength = 2;
                
                this.feeInformationComplete = (this.model.advisorFeeDescription != null && this.model.advisorFeeDescription.length >= minLength);
            } else {
                this.feeInformationComplete = this.model.advisorFee != null && this.model.advisorFee >= 0;
            }
            //console.log("FEE INFO COMPLETE IS", this.feeInformationComplete);

            if (this.feeInformationComplete) {
                this.feeStatusColor = this.completeColor;
            } else {
                this.feeStatusColor = this.incompleteColor;
                this.showFeesPanel = true;
                everythingComplete = false;
                if (showMessage)
                    toastr.error("Can not save. Please finish updating fee section.");
            }

            if (this.accountApi.paccount && (this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS || this.accountApi.paccount.accountType == domains.InvestmentType.SMA)) {
                this.investmentInformationComplete = (this.model.amount > 0 && this.unallocatedInvestment == 0);

                if (this.investmentInformationComplete) {
                    this.investmentStatusColor = this.completeColor;
                } else {
                    this.investmentStatusColor = this.incompleteColor;
                    this.showInvestmentsPanel = true;
                    everythingComplete = false;
                    if (showMessage)
                        toastr.error("Can not save. Please finish updating investment section.");
                }
            }

            if (this.accountApi.paccount && this.accountApi.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS) {
                this.investmentInformationComplete = (this.model.amount > 0 && this.model.investmentDescription && this.model.investmentDescription.length > 0);

                if (this.investmentInformationComplete) {
                    this.investmentStatusColor = this.completeColor;
                } else {
                    this.investmentStatusColor = this.incompleteColor;
                    this.showInvestmentsPanel = true;
                    everythingComplete = false;
                    if (showMessage)
                        toastr.error("Can not save. Please finish updating investment section.");
                }
            }

            // Check advanced billing completeness
            this.checkBillingComplete();
            if (!this.billingInformationComplete) {
                this.showBillingPanel = true;
                everythingComplete = false;
                if (showMessage)
                    toastr.error("Can not save. Please finish updating billing section.");
            }

            this.checkIfSigningComplete();

            return everythingComplete;
        }

        checkIfSigningComplete(): boolean {
            this.signingInformationComplete = (this.accountApi.paccount && this.accountApi.paccount.proposal && (this.accountApi.paccount.proposal.proposalState == domains.ProposalState.SIGNED || this.accountApi.paccount.proposal.proposalState == domains.ProposalState.ACTIVE));
            if (this.signingInformationComplete) {
                this.signingStatusColor = this.completeColor;
                return true;
            } else {
                this.signingStatusColor = this.incompleteColor;
                this.showSigningPanel = true;
                return false;
            }
        }

        onChangeAccountOpenStatus(): void {
            this.model.accountSetupOpen = !this.model.accountSetupOpen;
            this.onAccountOpenStatusChanged({
                status: this.model.accountSetupOpen = !this.model.accountSetupOpen
            });
            this.model.amount = 0;
            this.model.description = null;
            this.model.isDiscretionDocumentationOnFile = false;
            this.amountChanged(true);
            this.accountApi.investmentSetupDirty = true;
        }

        amountChanged(changedByUserOnUI: boolean = false): void {
            if (this.model && this.model.investmentModels) {
                for (var i = 0; i < this.model.investmentModels.length; i++) {
                    this.model.investmentModels[i].amount = this.model.investmentModels[i].percentage * this.model.amount;
                    this.model.investmentModels[i].managerFeeAmount = this.model.investmentModels[i].amount * this.model.investmentModels[i].managerFeePercentage;
                }
            }
            this.checkIfFieldsComplete("Amount");
            if (changedByUserOnUI) {
                this.accountApi.investmentSetupDirty = true;
            }
        };

        advisorFeeChanged(): void {
            //console.log("IN ADVISOR FEE CHANGED!");
            this.checkIfFieldsComplete("AdvisorFee");
            this.accountApi.feeSetupDirty = true;
        }

        pricingTypeChanged(): void {
            //console.log("IN PRICING TYPE CHANGED!");
            this.checkIfFieldsComplete("PricingType");
            this.accountApi.feeSetupDirty = true;
        };

        onAdvisorBillingTypeSelected(clearFeeValues: boolean = true): void {
            this.model.advisorFeeBillingType = this.selAdvisorBillingType.value;
            if (clearFeeValues) {
                this.model.advisorFee = 0;
                this.model.advisorFeeDescription = null;
                this.accountApi.feeSetupDirty = true;
            }
        }

        onFeeStructureChange(feeStructure: string, isValid: boolean, validationMessage: string): void {
            this.model.advisorFeeDescription = feeStructure;
            this.accountApi.feeSetupDirty = true;
        }

        selectAdvisorBillingType(): void {
            if (this.billingTypes) {
                var thInd = this.billingTypes.map(m => m.value).indexOf(this.model.advisorFeeBillingType);
                if (thInd >= 0) {
                    this.selAdvisorBillingType = this.billingTypes[thInd];
                    this.onAdvisorBillingTypeSelected(false);
                }
            }
        }

        // --- Advanced Billing methods ---

        onBillingStyleSelected(): void {
            this.advancedBilling.style = this.selBillingStyle ? { value: this.selBillingStyle.value, description: this.selBillingStyle.description } : null;
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            } else {
                this.selBillingFrequency = null;
                this.selBillingCycleMonth = null;
                this.advancedBilling.frequency = null;
                this.advancedBilling.cycleMonth = null;
                this.billingCycleMonthOptions = [];
            }
            this.syncAdvancedBillingToModel();
        }

        onBillingFrequencySelected(): void {
            this.advancedBilling.frequency = this.selBillingFrequency ? { value: this.selBillingFrequency.value, description: this.selBillingFrequency.description } : null;
            this.selBillingCycleMonth = null;
            this.advancedBilling.cycleMonth = null;
            this.updateCycleMonthOptions();
            this.syncAdvancedBillingToModel();
        }

        onBillingCycleMonthSelected(): void {
            this.advancedBilling.cycleMonth = this.selBillingCycleMonth ? { value: this.selBillingCycleMonth.value, description: this.selBillingCycleMonth.description } : null;
            this.syncAdvancedBillingToModel();
        }

        private applyBillingDefaultsForHiddenFields(): void {
            if (!this.advancedBilling.style) {
                return;
            }

            if (!this.selBillingFrequency) {
                this.selBillingFrequency = this.billingFrequencies.find(f => f.value === 1) || null;
            }

            if (this.selBillingFrequency) {
                this.advancedBilling.frequency = {
                    value: this.selBillingFrequency.value,
                    description: this.selBillingFrequency.description
                };
            }

            this.updateCycleMonthOptions();

            if (!this.selBillingCycleMonth) {
                this.selBillingCycleMonth = this.billingCycleMonthOptions.find(c => c.value === 1)
                    || this.billingCycleMonthOptions[0]
                    || null;
            }

            if (this.selBillingCycleMonth) {
                this.advancedBilling.cycleMonth = {
                    value: this.selBillingCycleMonth.value,
                    description: this.selBillingCycleMonth.description
                };
            }
        }

        updateCycleMonthOptions(): void {
            if (!this.selBillingFrequency) {
                this.billingCycleMonthOptions = [];
                return;
            }
            switch (this.selBillingFrequency.value) {
                case 1: // Monthly
                    this.billingCycleMonthOptions = [{ value: 1, description: "Every Month" }];
                    break;
                case 2: // Quarterly
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Quarter" },
                        { value: 2, description: "Month 2 of Quarter" },
                        { value: 3, description: "Month 3 of Quarter" }
                    ];
                    break;
                case 3: // Tri-Annual
                case 5: // Annual
                case 6: // At-Maturity
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Year" }, { value: 2, description: "Month 2 of Year" },
                        { value: 3, description: "Month 3 of Year" }, { value: 4, description: "Month 4 of Year" },
                        { value: 5, description: "Month 5 of Year" }, { value: 6, description: "Month 6 of Year" },
                        { value: 7, description: "Month 7 of Year" }, { value: 8, description: "Month 8 of Year" },
                        { value: 9, description: "Month 9 of Year" }, { value: 10, description: "Month 10 of Year" },
                        { value: 11, description: "Month 11 of Year" }, { value: 12, description: "Month 12 of Year" }
                    ];
                    break;
                case 4: // Semi-Annual
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Semi-Annual Cycle" }, { value: 2, description: "Month 2 of Semi-Annual Cycle" },
                        { value: 3, description: "Month 3 of Semi-Annual Cycle" }, { value: 4, description: "Month 4 of Semi-Annual Cycle" },
                        { value: 5, description: "Month 5 of Semi-Annual Cycle" }, { value: 6, description: "Month 6 of Semi-Annual Cycle" }
                    ];
                    break;
                default:
                    this.billingCycleMonthOptions = [];
                    break;
            }
        }

        syncAdvancedBillingToModel(): void {
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            }
            this.model.advancedBillingInfo = JSON.stringify(this.advancedBilling);
            this.checkBillingComplete();
            this.accountApi.feeSetupDirty = true;
        }

        checkBillingComplete(): void {
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            }
            this.billingInformationComplete = !!(this.advancedBilling.style && this.advancedBilling.frequency && this.advancedBilling.cycleMonth);
            this.billingStatusColor = this.billingInformationComplete ? this.completeColor : this.incompleteColor;
        }

        toggleBillingPanel(): void {
            this.showBillingPanel = !this.showBillingPanel;
        }

        restoreAdvancedBilling(): void {
            if (this.model.advancedBillingInfo) {
                try {
                    this.advancedBilling = JSON.parse(this.model.advancedBillingInfo);
                } catch (e) {
                    this.advancedBilling = {};
                }
            } else {
                this.advancedBilling = {};
            }

            if (this.advancedBilling.style) {
                this.selBillingStyle = this.billingStyles.find(s => s.value === this.advancedBilling.style.value) || null;
            }
            if (this.advancedBilling.frequency) {
                this.selBillingFrequency = this.billingFrequencies.find(f => f.value === this.advancedBilling.frequency.value) || null;
                this.updateCycleMonthOptions();
            }
            if (this.advancedBilling.cycleMonth) {
                this.selBillingCycleMonth = this.billingCycleMonthOptions.find(c => c.value === this.advancedBilling.cycleMonth.value) || null;
            }
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            }
            this.checkBillingComplete();
        }

        invDescChanged(): void {
            //console.log("IN INV DESC CHANGED!");
            this.checkIfFieldsComplete("InvestmentDescription");
            this.accountApi.investmentSetupDirty = true;
        };

        addInvestment(): void {

            if (!this.selProduct) {
                toastr.error("Please select product from the Product list");
                return;
            }

            const isOrionEclipseModel = this.selProduct.managerName.indexOf('Orion') === 0;
            if (isOrionEclipseModel && this.im.percentage != 100) {
                toastr.error("Orion (Eclipse) model must be only investment and 100% allocated");
                this.im.percentage = 100;
                return null;
            }

            if (this.unallocatedInvestment - this.im.percentage < 0) {
                toastr.error("You cannot allocate more than 100% of investments.");
                this.im.percentage = this.unallocatedInvestment;
                return null;
            }
            else if (this.im.percentage <= 0 || !this.im.percentage) {
                toastr.error("Investment must be greather then zero");
                return null;
            }

            //this.im.investmentModelId = this.im.investmentModel.id;
            this.im.percentage = this.im.percentage / 100;
            this.im.managerFeePercentage = this.selProduct.managerFee;
            this.im.amount = this.im.percentage * this.model.amount;
            this.im.managerFeeAmount = 0; //this.im.amount * this.im.managerFeePercentage;

            this.im.managerProductId = this.selProduct.managerProductId;
            this.im.managerProductName = this.selProduct.name;
            this.im.managerId = this.selProduct.managerId;
            this.im.managerName = this.selProduct.managerName;
            this.im.productTypeId = this.selProduct.productTypeId;
            this.im.productTypeName = this.selProduct.productTypeName;

            this.model.investmentModels.push(this.im);

            this.unallocatedInvestment = this.unallocatedInvestment - this.im.percentage * 100;

            this.im = {};
            this.im.percentage = this.unallocatedInvestment;
        };

        removeInvestment(im: domains.IProposalInvestmentModel): void {
            var ind = this.model.investmentModels.indexOf(im);
            if (ind >= 0) {
                this.unallocatedInvestment = this.unallocatedInvestment + im.percentage * 100;
                if (this.unallocatedInvestment > 100)
                    this.unallocatedInvestment = 100;
                this.im.percentage = this.unallocatedInvestment;
                this.model.investmentModels.splice(ind, 1);
                this.deactivatedInvestments.splice(ind, 1);
            }
            this.accountApi.investmentSetupDirty = true;
        };

        checkIsSelectedProductProposalInvestmentModels(accountId: number): void {
            this.advisorService.checkIsProductInactiveForProposalInvestments(accountId)
                .then(response => {
                    this.deactivatedInvestments = response.data;
                })
                .catch(error => {
                    toastr.error("Unable to check product.");
                })
        };

        completeSigning(): void {
            this.createOrUpdateProposal("S");
        }

        createProposal(): void {
            this.createOrUpdateProposal("C");
        }

        updateProposal(): void {
            this.createOrUpdateProposal("U");
        }

        createOrUpdateProposal(action: string): void {
            if (action == "C")
                this.creatingProposalLadda = true;
            else if (action == "U")
                this.updatingProposalLadda = true;
            else if (action == "S")
                this.completeSigningLadda = true;

            // Only do full form validation when a servicer is modifying this form
            // Advisors need to be able to save whatever data they know at the time
            // they press save, and they might not know everything.
            if (this.impersonatedByServicer == true) {
                //console.log("AMOUNT BEFORE VALIDATION", this.model.amount);
                if (
                    !this.validateProposalForm()
                    || !this.checkIfFieldsComplete("CHECKBEFORESAVE", false, true)
                ) {
                    if (action == "C")
                        this.creatingProposalLadda = false;
                    else if (action == "U")
                        this.updatingProposalLadda = false;
                    else if (action == "S")
                        this.completeSigningLadda = false;
                    //console.log("VALIDATE FORM FAILED");
                    //console.log("AMOUNT AFTER VALIDATION", this.model.amount);
                    return;
                }
                //console.log("PASSED VALIDATION");
            }

            // 
            if (this.model.accountSetupOpen && this.showCheckBox) {
                this.model.description = null;
                this.model.amount = null;
            }

            //only for broker dealer - if they defined
            // GEORGE REVIEW
            if (this.rtq && this.rtq.id && this.rtq.id > 0) {
                this.model.rtqId = this.rtq.id;
            }

            //if (this.model.proposalState == domains.ProposalState.SIGNED || this.model.isDiscretionDocumentationOnFile)
            //    this.model.proposalState = domains.ProposalState.ACTIVE;

            if (this.deactivatedInvestments.length != 0) {
                this.deactivatedInvestments
                    .map(v => toastr.error("Selected product: " + v.managerProductName + " is not active please select other one."));
                if (action == "C")
                    this.creatingProposalLadda = false;
                else if (action == "U")
                    this.updatingProposalLadda = false;
                else if (action == "S")
                    this.completeSigningLadda = false;
                return;
            }

            if (!this.isHhrProposal) {
                this.model.titleId = this.accountApi.paccount.titleId;
                this.model.accountId = this.accountApi.paccount.id;
            }

            if (this.accountApi.paccount.setupCustodianId != null) {
                const custodianAdvisoryFirm = this.custodians.filter(w => w.custodianId == this.accountApi.paccount.setupCustodianId);
                // this should always be found, otherwise the user should not have been able to select this custodian
                if (custodianAdvisoryFirm.length > 0)
                    this.model.custodianAdvisoryFirmId = custodianAdvisoryFirm[0].id;
                else
                    this.model.custodianAdvisoryFirmId = null;
            }
            else
                this.model.custodianAdvisoryFirmId = null;

            if (this.selPricingType)
                this.model.custodianPricingType = this.selPricingType.value;
            else
                this.model.custodianPricingType = null;

            // If the first proposal, copy the account name as the proposal description
            if (!this.investmentChange) {
                this.model.description = this.accountApi.paccount.name;
            }

            this.onSave().then(() => {
                this.advisorService.newCreateOrUpdateProposal(this.model)
                    .then(response => {
                        //this.model = response.data;
                        angular.copy(response.data, this.model);
                        this.accountId = this.model.accountId;
                        this.accountApi.paccount.proposal = this.model;
                        this.proposalForEdit = this.model;

                        // notify angular that account has been changed...
                        //let tmp = this.account;
                        //this.account = {};
                        //this.account = tmp;

                        var typ = "Investments and fees";
                        if (this.model.accountSetupOpen)
                            typ = "Setup";

                        if (this.proposalForEdit.id) {
                            toastr.info(`${typ} successfully updated.`);
                        } else {
                            if (this.impersonatedByServicer) {
                                toastr.success(`${typ} successfully saved.`);
                            } else {
                                toastr.success("Account has been added to the queue and is ready for the Service Team to take over account opening.");
                                //toastr.success(`Account successfully submitted.`);
                            }
                        }

                        this.onProposalCreate({ proposal: response.data });

                        // GL added this line so that after creating a proposal the messages after
                        // pressing the save button ("update" vs "modify") will work in the new-account-wiz.
                        //this.proposalForEdit.id = this.model.id;

                        if (this.investmentChange) {
                            this.closeFrom();
                        }

                        this.accountApi.investmentSetupDirty = false;
                        this.accountApi.feeSetupDirty = false;
                        // Refresh the proposal doc list
                        if (this.dmsListCtrl) {
                            this.dmsListCtrl.refresh();
                        }
                        this.collapseCompleted();

                        // automaticaly sign proposal after creation
                        this.model.isDiscretionDocumentationOnFile = true;
                        this.signProposal(this.fuValue);

                    }, err => this.generalService.showError(err)).finally(() => {
                        if (action == "C")
                            this.creatingProposalLadda = false;
                        else if (action == "U")
                            this.updatingProposalLadda = false;
                        else if (action == "S")
                            this.completeSigningLadda = false;
                    });
            });
            //.finally(() => {
            //    if (action == "C")
            //        this.creatingProposalLadda = false;
            //    else if (action == "U")
            //        this.updatingProposalLadda = false;
            //    else if (action == "S")
            //        this.completeSigningLadda = false;
            //});
        }

        signProposal(doc: any): void {
            this.signingProposalLadda = true;

            this.advisorService
                .signProposal(this.model)
                .then((response) => {
                    angular.copy(response.data, this.model);
                    this.accountApi.paccount.proposal = this.model;

                    this.checkIfFieldsComplete("PROPOSAL_SIGNED",false);

                    this.collapseSigned();

                    // this event can be used if we wish activate proposal after signing
                    this.onProposalSign({ proposal: this.model });

                }, err => this.generalService.showError(err)).finally(() => {
                    this.signingProposalLadda = false;
                });
        }

        printInfo(): boolean {
            //console.log("In PrintInfo in NEW CU PROPOSAL -- ACCOUNT TYPE:", this.accountApi.paccount.accountType);
            return true;
        };

        setProposal(proposal: domains.IProposal): void {
            //console.log("NewCuProposal: setting proposal");
            if (this.investmentChange) {
                this.model = this.proposalForEdit;
                this.accountId = this.model.accountId;
                this.unallocatedInvestment = 0;
            } else {
                if (proposal != null) {
                    //console.log("384723847283748234 SETTING PROPOSAL TO:", proposal);
                    this.model = proposal;
                    this.selectTimeHorizon();
                    //this.bindCustodianDdFromModel();
                    this.unallocatedInvestment = 0;
                } else {
                    this.setUpNewProposal();
                    this.unallocatedInvestment = 100;
                }
            }
            this.accountId = this.model.accountId;

            // ? not sure what these are used for ?
            //if (this.model.advisorCreate)
            //    this.model.advisorCreate.companyGroup = null;
            //this.model.title = null;

            //this.unallocatedInvestment = 0;
            this.im.percentage = this.unallocatedInvestment;
            if (this.model.custodianPricingType >= 0) {
                this.selPricingType = <domains.ILOV>{ value: this.model.custodianPricingType };
            }
            this.selectAdvisorBillingType();
            this.restoreAdvancedBilling();
            //this.accountApi.paccount.proposal = this.model;
            this.checkIfFieldsComplete("SET_PROPOSAL", false);
            this.accountApi.investmentSetupDirty = false;
            // Inside setUpNewProposal we may have pre-populated pricing type, if it is populated
            // adter initial setup (model.id == 0), set the fee setup dirty flag to true.
            //if (this.model.id == 0 && this.selPricingType != null)
            //    this.accountApi.feeSetupDirty = true;
            //else
            //    this.accountApi.feeSetupDirty = false;
            this.accountApi.feeSetupDirty = false;
        };

        validateProposalForm(): boolean {

            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["proposalForm"]);

            if (!formIsValid) {
                toastr.error("Proposal form is not complete. Please correct errors and try again.");
                return false;
            }

            //console.log("SETUP OPEN", this.model.accountSetupOpen);
            //console.log("INVESTMENT AMOUNT", this.model.amount);

            if (!this.investmentChange && !this.model.accountSetupOpen && this.model.amount <= 0) {
                toastr.error("Investment amount must be greater than 0.");
                return false;
            }

            if (this.model.advisorFeeBillingType === null || this.model.advisorFeeBillingType === undefined) {
                toastr.error("Advisor Fee Billing type needs to be selected.");
                this.model.advisorFeeBillingType = domains.FeeBillingType.Percentage;
                return false;
            }

            if (this.model.advisorFeeBillingType === domains.FeeBillingType.Tiered && (!this.model.advisorFeeDescription || this.model.advisorFeeDescription.length < 15)) {
                let feeBypassOrion = false;
                // Try to parse as new format
                try {
                    const parsed = JSON.parse(this.model.advisorFeeDescription || '{}');
                    // Check if it's the new format with empty items or null orionFeeScheduleId
                    if (parsed && typeof parsed === 'object' && 'items' in parsed) {
                        // Allow empty items if orionFeeScheduleId is null (checkbox checked)
                        if (!parsed.orionFeeScheduleId && (!parsed.items || parsed.items.length === 0)) {
                            // This is valid - fee needs to be created in Orion
                            feeBypassOrion = true;
                        }
                    }
                } catch (e) {
                    // Not valid JSON or old format
                }
                
                // Allow empty array "[]" as valid when advisor indicates fee needs to be created in Orion
                if (!feeBypassOrion && this.model.advisorFeeDescription !== "[]") {
                    toastr.error("Advisor Fee structure must have at least 15 characters or be marked as 'needs to be created in Orion'.");
                    return false;
                }
            }

            if ([domains.FeeBillingType.Percentage, domains.FeeBillingType.Amount].includes(this.model.advisorFeeBillingType)) {
                if (this.model.advisorFee == null || this.model.advisorFee < 0) {
                    toastr.error("Please enter a valid advisor fee (0 or greater). Even if you see 0.00%, type 0 to confirm no fee.");
                    this.model.advisorFee = 0;
                    return false;
                }

                if ((this.model.advisorFeeBillingType ?? domains.FeeBillingType.Percentage) === domains.FeeBillingType.Percentage && this.model.advisorFee > 100) {
                    toastr.error("Advisor fee needs to be between 0% and 100%.");
                    // this.model.advisorFee = 0;
                    return false;
                }
            }

            //console.log("UNALLO INVEST", this.unallocatedInvestment);
            //console.log("HAS INVEST", this.hasInvestmentModel());
            //console.log("IDFOREDIT INVEST", this.proposalForEdit.id);

            if (this.unallocatedInvestment != 0 && this.hasInvestmentModel() && !this.proposalForEdit.id) {
                toastr.error("Please finish allocating investments");
                return false;
            }

            // Validate advanced billing
            if (!this.advancedBilling.style) {
                toastr.error("Please select a billing style.");
                return false;
            }

            this.applyBillingDefaultsForHiddenFields();

            if (!this.advancedBilling.frequency || !this.advancedBilling.cycleMonth) {
                toastr.error("Billing defaults are missing. Please reselect billing style.");
                return false;
            }
            this.model.advancedBillingInfo = JSON.stringify(this.advancedBilling);

            return formIsValid;
        };

        selectTimeHorizon(): void {
            if (this.timesHorizons) {
                var thInd = this.timesHorizons.map(m => m.value).indexOf(this.model.timeHorizon);
                if (thInd >= 0) {
                    this.selectedTimeHorizon = this.timesHorizons[thInd];
                    //console.log(this.selectedTimeHorizon);
                }
            }
        };

        loadProposal(proposalId: number): void {
            //console.log(`929292929292992929292NewCuProposal: Loading proposal ${proposalId} ...`);
            this.advisorService.getProposal(proposalId)
                .then(response => {
                    this.setProposal(response.data);
                    if (!this.readyDone) {
                        this.readyDone = true;
                        this.iAmReady({ ctrl: this });
                    }
                }, err => this.generalService.showError(err));
        };

        loadOtherAccountProposalFees(): void {
            this.advisorService.getOtherAccountProposalFees(this.accountApi.paccount.id)
                .then(response => {
                    if (response && response.data != null && response.data.length > 0) {
                        this.otherAccountFees = response.data;
                    }
                    //console.log("Fees on other accounts:", this.otherAccountFees);
                }, err => this.generalService.showError(err));
        };

        loadWorkingProposal(accountId: number): void {
            //console.log(`NewCuProposal: Loading working proposal for account ${accountId} ...`);
            this.advisorService.getWorkingProposal(accountId)
                .then(response => {
                    this.setProposal(response.data);
                }, err => this.generalService.showError(err));
        };

        loadManagers(advisoryFirmId: number): ng.IPromise<domains.IAdvisoryFirmManager[]> {
            // we need to filter managers by product type if product type selected on first screen
            //console.log(`NewCuProposal: Loading managers for advisory firm ${advisoryFirmId} ...`);
            return this.advisoryFirmApi.getManagers(advisoryFirmId)
                .then(response => {
                    this.managers = response.data;
                    // console.log("CuProposal: Managers loaded...", this.managers);
                    return this.managers;
                }, err => this.generalService.showError(err));
        };

        loadProducts(advisoryFirmId: number): ng.IPromise<domains.IAdvisoryFirmProduct[]> {
            //console.log(`NewCuProposal: Loading products for the firm: [${advisoryFirmId}], tampId: [${this.accountApi.paccount.tampId}] ...`);
            return this.advisoryFirmApi.getProducts(advisoryFirmId, this.accountApi.paccount.tampId)
                .then(response => {
                    this.products = response.data;
                    // console.log(`Products has been loaded`, this.products.length, this.products);
                    this.filterManagers();
                    return response.data;
                }, err => toastr.error("Products has not been loaded. " + err.data));
        };

        filterProducts() {

            //console.log("Filtering products...");
            // console.log("Filtering products...", this.products, "Manager", this.managers, " Selected manager: ", this.selManager);

            // manager must be selected first
            if (!this.selManager) {
                return;
            }

            // we need to filter products by manager
            this.filteredProducts = this.products.filter(v => v.managerId == this.selManager.managerId);

            // console.log("Stage 1: ", this.filteredProducts);

            // if we have product type selected then filter products by managerid and products type
            if (this.accountApi.paccount && this.accountApi.paccount.productTypeId > 0) {
                this.filteredProducts = this.filteredProducts.filter(v => v.productTypeId == this.accountApi.paccount.productTypeId);
                //console.log("Stage 2: ", this.filteredProducts);
            }
            
            // Try to auto-select product from Orion account data after filtering
            this.trySelectProductFromOrion();
        };

        trySelectProductFromOrion(): void {
            // Auto-select product based on Orion account modelName if account not yet created
            console.log(`trySelectProductFromOrion called. OrionAccountData:`, this.orionAccountData);
            console.log(`Filtered products count: ${this.filteredProducts?.length || 0}`);
            console.log(`Account ID: ${this.accountApi.pcustodianAccount?.id || 'none'}`);
            
            if (this.orionAccountData && this.orionAccountData.modelName &&
                (!this.accountApi.pcustodianAccount.id || this.accountApi.pcustodianAccount.id <= 0) &&
                this.filteredProducts && this.filteredProducts.length > 0) {
                
                // console.log(`Trying to auto-select product from Orion account modelName: ${this.orionAccountData.modelName}`);
                const modelNameToMatch = this.orionAccountData.modelName.trim().toLowerCase();
                console.log(`Looking for product with name matching: ${modelNameToMatch}`);
                
                // Try to find a product whose name matches the Orion account modelName
                // Extract model name from product name by removing "prefix - " and "(...)" pattern
                this.selProduct = this.filteredProducts.find(v => {
                    let productName = (v.name || '').trim();
                    // console.log(`Checking product: ${v.name}`);
                    
                    // Extract the core model name from product name
                    // Pattern: "SomePrefix - ModelName(...)" or "ModelName(...)"
                    // Remove everything before " - " (if exists)
                    const dashIndex = productName.indexOf(' - ');
                    if (dashIndex > 0) {
                        productName = productName.substring(dashIndex + 3).trim();
                        // console.log(`  After removing prefix: ${productName}`);
                    }
                    
                    // Remove parentheses and everything after them
                    const parenIndex = productName.indexOf('(');
                    if (parenIndex > 0) {
                        productName = productName.substring(0, parenIndex).trim();
                        // console.log(`  After removing suffix: ${productName}`);
                    }
                    
                    const normalizedProductName = productName.toLowerCase();
                    // console.log(`  Final normalized: ${normalizedProductName} vs ${modelNameToMatch}`);
                    return normalizedProductName === modelNameToMatch;
                });
                
                if (this.selProduct) {
                    console.log(`Auto-selected product ${this.selProduct.name} based on Orion account modelName`);
                    this.accountApi.investmentSetupDirty = true;
                } else {
                    console.log(`No matching product found for Orion modelName: ${this.orionAccountData.modelName}`);
                }
            } else {
                console.log(`Skipping product auto-selection. Conditions not met.`);
            }
        }

        filterManagers() {
            // console.log(`Filtering managers...`);
            let tmpMgrIds: number[] = [];
            if (this.accountApi.paccount && this.accountApi.paccount.productTypeId > 0) {
                //console.log(`Filtering managers by productTypeId=${this.accountApi.paccount.productTypeId}`);
                tmpMgrIds = this.products.filter(v => v.productTypeId == this.accountApi.paccount.productTypeId).map(m => m.managerId);
            }
            else {
                //console.log(`Filtering managers by all products since productTypeId has not been set...`);
                tmpMgrIds = this.products.map(m => m.managerId);
            }

            // select distinct
            tmpMgrIds = tmpMgrIds.filter((v, ind, self) => self.indexOf(v) === ind);

            // console.log(`Managers from product ${tmpMgrIds.join(",")}`);
            this.filteredManagers = this.managers.filter(v => tmpMgrIds.indexOf(v.managerId) >= 0);

            // preselect first manager if available
            if (this.filteredManagers.length == 1) {
                this.selManager = this.filteredManagers[0];
                this.filterProducts();
            }
        };

        onManagerSelected() {
            this.filterProducts();
            this.accountApi.investmentSetupDirty = true;
        };

        loadInvestmentModels(advisoryFirmId: number): ng.IPromise<domains.IInvestmentModel[]> {
            return this.advisorService.getInvestmentModels(advisoryFirmId)
                .then(response => this.investmentModels = response.data, reason => toastr.error("InvestmentModels error " + reason));
        };

        onChangedSkippOption(): void {
            this.onCheckedSkippingOption({ isDiscretionDocumentationOnFile: this.model.isDiscretionDocumentationOnFile });
        }

        loadFees(advisoryFirmId: number): void {
            this.advisorService.getOtherProposalFees(advisoryFirmId)
                .then((response) => {
                    this.otherFees = response.data;
                    //this.model.platformFee = response.data.platformFee;
                    //if (this.model && this.model.custodianFee && this.otherFees.custodianFee.length > 0) {
                    //    this.model.custodianFee = this.otherFees.custodianFee.filter(item => item.id == this.model.custodianFee.id)[0];
                    //}
                    // this is default advisor fee which can be overridden by Advisory Manager
                    // console.log(`Setting advisory fee to ${response.data.advisorFee.percentage}`, response.data.advisorFee);
                    this.model.advisorFee = response.data.advisorFee.percentage / 100;

                }, err => this.generalService.showError(err));
        };

        loadCustodiansForAdvisoryFirm(advisoryFirmId: number): ng.IPromise<void> {
            //console.log("NewCuProposal: Loading Custodians...");
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    this.custodians = data.data;
                    //this.bindCustodianDdFromModel();
                }, err => this.generalService.showError(err));
        };

        timeHorizonChanged(): void {
            this.model.timeHorizon = this.selectedTimeHorizon.value;
        }

        initSelPricingType(): void {
            if ((!this.proposalId) && this.accountApi.paccount && (this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS || this.accountApi.paccount.accountType == domains.InvestmentType.SMA)) {
                //console.log("PROPOSAL --- YES I AM SETTING PRICING TYPE");
                this.selPricingType = <domains.ILOV>{ value: domains.PricingType.ASSET_BASED };
            } else {
                this.selPricingType = <domains.ILOV>{ value: domains.PricingType.ASSET_BASED };
            }
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;

                    this.timesHorizons = this.lovs.filter(v => v.lovType === domains.LovType.TIME_H);

                    this.selectTimeHorizon();

                    this.pricingTypes = data.filter(f => f.lovType === domains.LovType.PRICING_TYPE);

                    this.initSelPricingType()

                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        hasInvestmentModel(): boolean {
            //console.log("IN HAS IM --- Acct Type is:", this.account.accountType )
            return this.accountApi.paccount && (this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS || this.accountApi.paccount.accountType == domains.InvestmentType.SMA) /*|| this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS*/;
        };

        isInternalTamp(): boolean {
            return this.accountApi.paccount && this.accountApi.paccount.tampType === domains.TampType.INTERNAL_TAMP;
        }

        setUpNewProposal(): void {
            //console.log(".... IN SET UP NEW PROPOSAL *#*#*#*#*#*#*#*#*#*#*#*#*#*#* ...");
            this.model = {
                id: 0,
                proposalState: domains.ProposalState.PREPARING, /*custodianFee: { id: 0 },*/
                investmentModels: [],
                //advisorFee: 0,
                accountSetupOpen: false
            };

            // If we are in new account opening and are copying from another account,
            // copy the advisory fee from the account being copied into this new proposal
            if (this.accountApi.paccount.id > 0 && this.accountApi.paccount.setupRelatedAccountId > 0
                && (this.accountApi.paccount.accountType == this.accountType_IndividualHoldings || this.accountApi.paccount.accountType == this.accountType_ManagedModels || this.accountApi.paccount.accountType == this.accountType_SMA)) {
                this.advisorService.getAdvisorFee(this.accountApi.paccount.setupRelatedAccountId)
                    .then(response => {
                        this.model.advisorFee = response.data * 100;
                    });
                // Do not report an error if not found
                //, err => this.generalService.showError(err));
            }

            this.unallocatedInvestment = 100;
            this.im.percentage = this.unallocatedInvestment;

            this.resetSelected();

            // Initialize billing type to Percentage by default
            if (!this.model.advisorFeeBillingType) {
                this.model.advisorFeeBillingType = domains.FeeBillingType.Percentage;
            }
            this.selectAdvisorBillingType();

            this.model.rtq = this.rtq;

            // we need to reload data
            this.isAdvisoryFirmLoaded = false;

            this.advisoryFirmId = this.accountApi.paccount.advisoryFirm.id;

            this.loadAdvisoryFirm(this.advisoryFirmId);

            this.checkIfFieldsComplete("SETUPNEW", false);

            // this.amountChanged();
        }

        public showCheckBox(): boolean {
            // On an investment change do not offer the 'setup only' option
            // Offer this option for individual holdings, managed models and sma
            return !this.investmentChange &&
                // ( ( this.model.proposalState == domains.ProposalState.PREPARING) || this.model.accountSetupOpen) &&
                (this.accountApi.paccount.accountType === domains.InvestmentType.INDIVIDUAL_HOLDINGS
                    || this.accountApi.paccount.accountType === domains.InvestmentType.MANAGED_MODELS
                    || this.accountApi.paccount.accountType === domains.InvestmentType.SMA);
        }

        $onInit(): void {

            //console.log("NewCuProposal: onInit fired");

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.impersonatedByServicer = (this.user.impersonatedByRole == "SERVICER" || this.user.impersonatedByRole == "SERVICER_LEAD" || this.user.impersonatedByRole == "SERVICER_ADMIN")
                this.currentAdvisor = this.user.advisor;
            });
            this.loadLovs();
            if (this.proposalId > 0) {
                this.loadProposal(this.proposalId);
            } else {
                this.readyDone = true;
                this.iAmReady({ ctrl: this });
                // Set custodian to be the custodian the advisor selected when they initialized the account
                //if (this.accountApi.paccount.setupCustodianId) {
                //    var cust = this.custodians.filter((v) => { return v.id == this.accountApi.paccount.setupCustodianId; });
                //    if (cust.length > 0) {
                //        this.selCustodian = cust[0];
                //    }
                //    console.log("CU-PROPOSAL - SET CUSTODIAN TO:", this.selCustodian);
                //}
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {

                // console.log(`CuProposal: onChanges fired ${key}`);

                if (key === "rtq") {
                    this.model.rtq = this.rtq;
                }
                //else if (key === "account" && this.accountApi.paccount && this.accountApi.paccount.id >= 0) {
                //    console.log("NewCuProposal: account received"/*, this.account*/);

                //    //if (this.account.ppAccountId && (this.account.ppAccountId > 0))
                //    //    this.thisAccountIsFromMapping = true;
                //    //else
                //    //    this.thisAccountIsFromMapping = false;

                //    // this.showCheckBox();
                //    if (this.accountApi.paccount && this.accountApi.paccount.proposal) {
                //        this.setProposal(this.accountApi.paccount.proposal);

                //        if (this.accountApi.paccount.id > 0)
                //            this.checkIsSelectedProductProposalInvestments(this.accountApi.paccount.id);

                //        //if (this.account.number) {
                //        //    this.thisAccountIsFromMapping = true;
                //        //}
                //    }
                //    if (this.accountApi.paccount.advisoryFirm) {
                //        // in this case we need to reload data: managers, products, fees, investment models etc...
                //        // baucene firm or tamp has been changed
                //        // we have space for optimization here
                //        this.isAdvisoryFirmLoaded = false;
                //        this.advisoryFirmId = this.accountApi.paccount.advisoryFirm.id;
                //        this.loadAdvisoryFirm(this.advisoryFirmId);
                //    }
                //}
                else if (key === "advisoryFirmId") {
                    this.loadAdvisoryFirm(this.advisoryFirmId);
                } else if (key === "proposalForEdit" && this.investmentChange) {
                    // console.log("CuProposal: proposal for edit received", this.model, this.rtq);
                    if (this.proposalForEdit.id) {
                        this.model = this.proposalForEdit;
                        this.accountId = this.model.accountId;
                        this.selectedTimeHorizon = this.timesHorizons[this.proposalForEdit.timeHorizon];
                        //this.bindCustodianDdFromModel();
                        this.unallocatedInvestment = 0;
                    } else {
                        this.setUpNewProposal();
                        this.accountId = this.model.accountId;
                        // Inside setUpNewProposal we may have pre-populated pricing type, if it is populated
                        // adter initial setup, set the fee setup dirty flag to true.
                        //if (this.selPricingType != null)
                        //    this.accountApi.feeSetupDirty = true;
                        //else
                        //    this.accountApi.feeSetupDirty = false;
                    }
                    this.accountApi.investmentSetupDirty = false;
                    this.accountApi.feeSetupDirty = false;
                }
            }
        }

        loadAdvisoryFirm(advisoryFirmId: number) {

            if (!advisoryFirmId) return;

            // load only once
            if (this.isAdvisoryFirmLoaded) return;

            this.isAdvisoryFirmLoaded = true;

            //console.log(`NewCuProposal: Loading fees, investment model and managers for advisory firm ${advisoryFirmId}`);

            this.loadCustodiansForAdvisoryFirm(advisoryFirmId);

            // Load fees in this place is not working, it is setting model.advisorfee and can
            // can overwrite the advisory fee that is on an exsting DB proposal...
            // Need to redo where these are loaded and used. For now this is OK because initial
            // client wants to default the advisor fee to 0.
            //this.loadFees(advisoryFirmId);
            this.loadInvestmentModels(advisoryFirmId);
            this.loadManagers(advisoryFirmId).then(d => this.loadProducts(advisoryFirmId));
        }

        //bindCustodianDdFromModel(): void {
        //    //console.log("MODEL:", this.model);
        //    //console.log("CUSTODIANS:", this.custodians);
        //    //console.log("MODEL CUSTODIAN ADVISORY FIRM ID:", this.model.custodianAdvisoryFirmId);

        //    if (this.model && this.custodians) {
        //        if (this.model.custodianAdvisoryFirmId) {
        //            var cust = this.custodians.filter((v) => { return v.id == this.model.custodianAdvisoryFirmId; });
        //            if (cust.length > 0) {
        //                this.selCustodian = cust[0];
        //            }
        //        }
        //    }
        //    if (this.model && this.model.custodianPricingType >= 0) {
        //        this.selPricingType = <domains.ILOV>{ value: this.model.custodianPricingType };
        //    }
        //}

        closeFrom(): void {
            this.cancelProposal({ status: true });
        }

        resetSelected(): void {
            this.selProduct = {};
            this.selManager = {}; 
            this.selectedTimeHorizon = {};
            this.initSelPricingType()
        }

        $routerOnActivate(next, previous) {
        }
    }


    class NewCuProposal implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        transclude: boolean;

        constructor() {
            this.controller = NewCuProposalController;
            this.controllerAs = "vm";
            this.transclude = true;
            this.bindings = {
                //account: "=",
                rtq: "<",
                onProposalCreate: "&",
                onProposalSign: "&",
                onAccountOpenStatusChanged: "&",
                onCheckedSkippingOption: "&",
                advisoryFirmId: "<",
                investmentChange: "<",
                iAmReady: "&",
                onSave: "&",
                cancelProposal: "&",
                proposalForEdit: "<",
                isHhrProposal: "@",
                custodianReadOnly: "<",
                orionAccountData: "<"
            };
            this.templateUrl = "spa/shared/common/new-cu-proposal.html";
        }
    }
    angular.module(Constants.APP).component("newCuProposal", new NewCuProposal());
}
